import { Alerts } from '../Alerts.js';
import { SubTemplateMap } from './alert-trigger-cell.js';

angular.module('logbook')
.directive('alertTriggerContainer', ['$timeout', '$q', '$http', '$compile', 'batchRequest', function($timeout, $q, $http, $compile, batchRequest)
{
	return {
		restrict: 'E',
		template: require('./alert-trigger-container.html'),
		scope: {
			onBind: '=',
			report: '=',
			selectedLog: '='
		},

		link: function(scope, element, attributes)
		{
			var triggersToDelete = [];
			var loadTriggerPromise = $q.defer();

			/**
			 * @type {AlertReportTrigger[]}
			 */
			scope.triggers = [];
			scope.templateSegments = [];


			scope.alertTriggerCell = {
				scopes: [],

				bound: function (triggerCellScope)
				{
					triggerCellScope.addParameterOptions(new SubTemplateMap(scope.templateSegments), scope.subTemplateId);
					
					// Recover deleted trigger if it was previously deleted before save transaction
					var deletionIndex = triggersToDelete.findIndex(function(deletedTrigger)
					{
						return deletedTrigger.trigger.alert === triggerCellScope.trigger.alert;
					});
					
					var triggerIndex = scope.triggers.findIndex(function(trigger)
					{
						return trigger.alert === triggerCellScope.trigger.alert;
					});
					
					if (deletionIndex > -1 && triggerIndex > -1)
					{
						triggerCellScope.trigger = triggersToDelete.splice(deletionIndex, 1)[0].trigger;
						
						var removed = scope.triggers.splice(triggerIndex, 1, triggerCellScope.trigger)[0];
						var removedIndex = scope.alertTriggerCell.scopes.findIndex(function(scope) { return scope.trigger === removed });
						if (removedIndex > -1)
							scope.alertTriggerCell.scopes[removedIndex].deleteTrigger();
					}
					
					if (0 > scope.alertTriggerCell.scopes.findIndex(function(scope) { return scope.trigger === triggerCellScope.trigger }))
						scope.alertTriggerCell.scopes.push(triggerCellScope);
				},

				onDelete: function (triggerCellScope)
				{
					var index = scope.triggers.findIndex(function (trigger) {
						return trigger === triggerCellScope.trigger;
					});

					var scopeIndex = scope.alertTriggerCell.scopes.findIndex(function(triggerScope)
					{
						return triggerScope === triggerCellScope
					});

					if (index > -1)
					{
						scope.triggers.splice(index, 1);
						scope.alertSelector.scope.applyFilter();
					}

					if (scopeIndex > -1)
						scope.alertTriggerCell.scopes.splice(scopeIndex, 1);
					
					triggersToDelete.push(
						{
							trigger: triggerCellScope.trigger,
							link: '/api/reportAlertTriggers/' + triggerCellScope.trigger.id
						})
				}
			};

			scope.alertSelector = {
				scope: undefined,
				buttonText: 'Attach Alert',

				select: function (alert) {
					var trigger = Alerts.createReportTrigger(scope.report, alert);
					trigger.alertObject = alert;

					scope.triggers.push(trigger);
					scope.alertSelector.scope.applyFilter();
				},

				bound: function (selectorModalScope) {
					scope.alertSelector.scope = selectorModalScope.selectorScope;
				},

				filter: function (alert) {
					// Filter the alert selector based on whether scope.triggers contains an a trigger with the same alert
					return alert.template === null && scope.triggers.findIndex(function (trigger) {
						return alert.complexObject.id === trigger.alertObject.complexObject.id;
					}) < 0;
				}
			};

			scope.loadTriggers = function () {
				return $q(function (resolve, reject) {
					if (scope.report == undefined || scope.report.id < 0) {
						reject();
						return;
					}
					
					if (!scope.report.complexObject)
					{
						resolve();
						return;
					}
					
					$http.get('/api/reportAlertTriggers', {
						params: {
							'report': scope.report.id
						}
					})
						.then(function (results) {
							scope.triggers.length = 0;
							results.data._embedded.reportAlertTriggers.forEach(function (trigger) {
								var alert = Alerts.createAlert(trigger.alert.logId, trigger.alert);
								trigger = Alerts.createReportTrigger(scope.report, alert, trigger);
								trigger.alertObject = alert;
								trigger.pruneBrokenMappings();

								if (!Array.isArray(scope.templateSegments)) scope.templateSegments = [];
								trigger.parameterMappings.forEach(function (param) {
									// Adds either the templateValue or string value as an available option
									if (param.templateValue) {
										scope.templateSegments.push(param.templateValue);
										param.templateSegment = param.templateValue.id;
									} else if (param.stringValue.length) {
										scope.templateSegments.push({id: undefined, name: param.stringValue})
									}
								});
								scope.triggers.push(trigger);
							});
							scope.alertSelector.scope.applyFilter();
							resolve();
						}, function () {
							reject();
						});
				});

			};

			scope.setReport = function (report) {
				scope.report = report;
				loadTriggerPromise = $q.defer();

				return scope.loadTriggers()
					.finally(function () {
						return loadTriggerPromise.resolve();
					});
			};

			scope.setSubTemplateIdFilter = function (id) {
				if (id && id.hasOwnProperty('id'))
					id = id.id;

				if (!isNaN(parseInt(id))) {
					scope.subTemplateId = id;
					loadTriggerPromise.promise
						.then(function () {
							scope.alertTriggerCell.scopes.forEach(function (triggerScope) {
								triggerScope.subTemplateId = scope.subTemplateId;
								triggerScope.refreshParameterTable();
							});
						})
				}
			};

			scope.setTemplateSegments = function (templateSegments) {
				var defer = $q.defer();

				if (!Array.isArray(templateSegments)) {
					defer.resolve();
					return defer.promise;
				}

				scope.templateSegments = templateSegments;
				loadTriggerPromise.promise
					.then(function () {
						var subTemplateMap = new SubTemplateMap(scope.templateSegments);
						scope.alertTriggerCell.scopes.forEach(function (triggerScope) {
							triggerScope.addParameterOptions(subTemplateMap, scope.subTemplateId);
						});

						defer.resolve();
					});

				return defer.promise;
			};

			scope.getSaveReadyStatus = function()
			{
				return scope.alertTriggerCell.scopes.every(function(cellScope) { return cellScope.getReadyForSave() })
			};
			
			/**
			 * Executes batch request to process deleted triggers and to save the triggers of its children
			 * @returns {Promise|Promise<unknown>}
			 */
			scope.saveTriggers = function()
			{
				return $q.all(scope.alertTriggerCell.scopes.map(function(triggerScope)
				{
					return triggerScope.saveTrigger();
				}))
					.then(function(requests)
					{
						return batchRequest.all(triggersToDelete.filter(function(trigger)
						{
							return trigger.trigger.id > 0;
							
						}).map(function(trigger)
						{
							return batchRequest.req('DELETE', trigger.link);
						})
							.concat(requests.reduce(function(arr, newArr)
							{
								return arr.concat(newArr);
							}, [])));
					});
			};


			var element = $(element).find('#selector-container')
				.html('<alert-selector-modal selected-log="selectedLog" button-text="{{alertSelector.buttonText}}" ' +
					'on-bind="alertSelector.bound" on-selection="alertSelector.select" filter="alertSelector.filter" select-one></alert-selector-modal>')
				.find('alert-selector-modal');

			//Attach and compile the alert selector as a directive
			$compile(element)(scope);

			scope.loadTriggers()
				.finally(function()
				{
					if (typeof scope.onBind === 'function')
						scope.onBind(scope);

					loadTriggerPromise.resolve();
				});

		}
	}
}]);